import { render, staticRenderFns } from "./SelectLanguages.vue?vue&type=template&id=1e7a90ff&scoped=true&"
import script from "./SelectLanguages.vue?vue&type=script&lang=js&"
export * from "./SelectLanguages.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguages.vue?vue&type=style&index=0&id=1e7a90ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7a90ff",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VPagination,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e7a90ff')) {
      api.createRecord('1e7a90ff', component.options)
    } else {
      api.reload('1e7a90ff', component.options)
    }
    module.hot.accept("./SelectLanguages.vue?vue&type=template&id=1e7a90ff&scoped=true&", function () {
      api.rerender('1e7a90ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectLanguages.vue"
export default component.exports